import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchDocuments } from '..';

export const usePatchDocuments = () => {
  const queryClient = useQueryClient();

  const onSuccess = async () => {
    await queryClient.invalidateQueries(['documents']);
    await queryClient.invalidateQueries(['documentsQueue']);
  };

  return useMutation({
    mutationFn: patchDocuments,
    onSuccess,
  });
};
